import { render } from "./AccountSection.vue?vue&type=template&id=de8b471e&scoped=true&ts=true"
import script from "./AccountSection.vue?vue&type=script&lang=ts"
export * from "./AccountSection.vue?vue&type=script&lang=ts"

import "./AccountSection.vue?vue&type=style&index=0&id=de8b471e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de8b471e"]])

export default __exports__